export default __webpack_public_path__ + "static/light-bulb--production-a4c8645e856e7d1a6825da28cae7a364.jpg";